import React from 'react';
import './Partners.css';

const Partners = () => {
    // We use the organizations mentioned in their projects as "Community Partners"
    // Since we don't have logos, we use a sleek typography-based marquee
    const partners = [
        "Nashua Soup Kitchen",
        "Lowell Transitional Living Center",
        "Lawrence House of Mercy",
        "Local NPOs",
        "Community Shelters"
    ];

    return (
        <section className="partners-section">
            <div className="container">
                <p className="partners-label">Empowering communities alongside trusted partners</p>
                <div className="partners-marquee-container">
                    <div className="partners-marquee">
                        {/* Duplicate the list for endless scroll effect */}
                        {[...partners, ...partners].map((partner, index) => (
                            <div key={index} className="partner-logo-placeholder">
                                {partner}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Partners;
